import './PasswordInput.scss';
import * as React from 'react';
import { omit } from 'lodash';
import classnames from 'classnames';
import Checkbox from './Checkbox';
export type Props = {
  invalid?: boolean;
  focusOnRender?: boolean;
  autoComplete?: string;
  name: string;
  value: string;
  onLight: boolean;
  onChange: (a: React.ChangeEvent<HTMLInputElement>) => void;
  onKeyPress?: (a: React.KeyboardEvent<HTMLInputElement>) => void;
  allowRevealedPassword?: boolean;
  revealed?: boolean;
  onToggleRevealed?: (revealed: boolean) => void;
  readOnly?: boolean;
  disabled?: boolean;
};
type State = {
  revealed: boolean;
};
/**
 * Password input, including a button to reveal the password as plain text.
 *
 * Pass in `revealed` and `onToggleRevealed` to control the state externally,
 * otherwise it will be managed automatically by this component.
 */
export default class PasswordInput extends React.Component<Props, State> {
  static defaultProps = {
    allowRevealedPassword: false,
    invalid: false,
    onLight: false,
  };
  state = {
    revealed: false,
  };
  node: HTMLInputElement | undefined | null;
  focus() {
    if (this.node != null) {
      this.node.focus();
    }
  }
  componentDidMount() {
    if (this.props.focusOnRender) {
      this.focus();
    }
  }
  toggleRevealed = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (this.props.onToggleRevealed != null) {
      this.props.onToggleRevealed(event.currentTarget.checked);
    } else {
      this.setState({
        revealed: event.currentTarget.checked,
      });
    }
  };
  render() {
    const { invalid, allowRevealedPassword, ...remainingProps } = this.props;
    const revealed =
      this.props.revealed != null ? this.props.revealed : this.state.revealed;
    return (
      <div className="PasswordInput">
        <input
          ref={(node) => (this.node = node)}
          className={classnames('PasswordInput-input', {
            'PasswordInput--invalid': invalid,
          })}
          type={revealed ? 'text' : 'password'}
          {...omit(
            remainingProps,
            'focusOnRender',
            'onToggleRevealed',
            'onLight',
            'revealed',
          )}
        />

        {allowRevealedPassword && (
          <Checkbox
            checked={revealed}
            onChange={this.toggleRevealed}
            tabIndex={-1}
            onLight={this.props.onLight}
            className="PasswordInput-revealCheckbox"
          >
            Show Password
          </Checkbox>
        )}
      </div>
    );
  }
}
